import { render, staticRenderFns } from "./SelectWorld.vue?vue&type=template&id=8589b478&scoped=true&"
import script from "./SelectWorld.vue?vue&type=script&lang=js&"
export * from "./SelectWorld.vue?vue&type=script&lang=js&"
import style0 from "./SelectWorld.vue?vue&type=style&index=0&id=8589b478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8589b478",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
